import axios from 'axios';

// Базовый адрес бэкенда.
// Локально (npm start) — localhost:8000. В интернете — берётся из настройки
// REACT_APP_API_URL, которую мы зададим в Render при сборке фронтенда.
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Где хранится токен входа в браузере
const TOKEN_KEY = 'mf_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Ко ВСЕМ запросам автоматически добавляем токен входа.
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Если сервер ответил 401 (токен истёк или недействителен) — выходим из аккаунта.
// Ошибку самого входа (/auth/login) не трогаем — её показывает страница входа.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const url = (error.config && error.config.url) || '';
    if (status === 401 && getToken() && !url.includes('/auth/login')) {
      clearToken();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
